var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.cssClass,attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer nofollow"}},[_vm._v("\n  "+_vm._s(_vm.__('View app'))+" "),_c('icon',{attrs:{"css-classes":"fgray","name":"external-link"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }